import {DetailViewSource} from './deal-payroll-detail.view.types';

export const GENERIC_DETAIL_ERROR_KEY = 'DEAL_PAYROLL_BREAKDOWN_LOAD_ERROR';
export const ACCESS_DENIED_DETAIL_ERROR_KEY = 'DEAL_PAYROLL_BREAKDOWN_ACCESS_DENIED';
export const SNAPSHOT_MISSING_CODE = 'DEAL_SNAPSHOT_MISSING';
export const SNAPSHOT_MISSING_DETAIL_ERROR_KEY = 'DEAL_PAYROLL_SNAPSHOT_MISSING';
export const FORBIDDEN_STATUS = 403;
export const PRIMARY_BLOCKER_INDEX = 0;
export const EMBEDDED_DETAIL_SOURCE = 'EMBEDDED' as DetailViewSource;
export const REMOTE_DETAIL_SOURCE = 'REMOTE' as DetailViewSource;



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/deal-payroll-detail/deal-payroll-detail.loader.constants.ts